import { isEmpty } from 'lodash';
import React from 'react';
import {
  BreadcrumbContainer,
  BreadcrumbArrow,
  BreadcrumbLabel,
  BreadcrumbWrapper,
  RelativeWrapper,
} from './styles/BreadcrumbBackTo.styled';
import { DWTCContext } from '../utils/context';

export default function BreadcrumbBackTo({ data, dir, id }) {
  const { link } = data;
  const { cssClass } = React.useContext(DWTCContext);
  return (
    isEmpty(link) || (
      <RelativeWrapper id={id}>
        <BreadcrumbContainer id="breadcrumbBackTo" dir={dir} className={cssClass}>
          <BreadcrumbWrapper href={link.url}>
            <BreadcrumbArrow />
            <BreadcrumbLabel dir={dir}>{link.name}</BreadcrumbLabel>
          </BreadcrumbWrapper>
        </BreadcrumbContainer>
      </RelativeWrapper>
    )
  );
}
